export default __webpack_public_path__ + "static/media/AIM-Village.1d3e6f33.jpg";